/**
 * SmartTempoPanelWrapper Component
 * Wrapper for Smart Tempo panel
 */

import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { SmartTempoPanel } from '../smarttempo';
import { toast } from 'sonner';

export const SmartTempoPanelWrapper = ({
  isOpen,
  onClose,
  tracks,
  audioContextRef,
  currentBpm,
  setBpm,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed top-20 right-4 z-50">
          <SmartTempoPanel
            audioBuffer={tracks.find(t => t.type === 'audio' && t.audioBuffer)?.audioBuffer || null}
            audioContext={audioContextRef?.current}
            currentBpm={currentBpm}
            onTempoChange={(newBpm) => {
              setBpm(newBpm);
              toast.success(`Tempo set to ${newBpm} BPM`);
            }}
            onClose={onClose}
            isVisible={isOpen}
          />
        </div>
      )}
    </AnimatePresence>
  );
};

export default SmartTempoPanelWrapper;
